import React, { useRef } from 'react'
import { useHistory } from 'react-router-dom'
import MainHeaderContainer from 'components/containers/header/MainHeaderContainer'
import MainBanner from 'components/containers/banner/MainBanner'
import MainList from 'components/containers/main/list/MainList'
// import MotishopBanner from 'components/presenters/commerce/banner/MotishopBanner'
import { getQueryStringObject } from 'utils/utils'
// import branddak from 'images/event/branddak_mini_banner.png'
// import branddak from 'images/event/branddak_mini_banner_monrning_goguma.png'
// import branddak from 'images/event/branddak_mini_banner2.png'
// import branddak from 'images/event/branddak_encore_mini_banner.png'
// import realplant from 'images/event/realplant_minit_banner_0525.png'
// import charmden from 'images/event/charmden_mini_banner.png'
import charmden from 'images/event/charmden_mini_banner2.png'
// import motishopBanner from 'images/event/motishop_mini_banner.png'

import { MainInner, MainBannerWrapper, MotishopBannerWrapper, BranddakBannerWrapper } from './style'
// import BranddakModal from 'components/containers/common/BranddakModal/BranddakModal'
import CharmdenModal from 'components/containers/common/CharmdenModal/CharmdenModal'

export default function MainLayout({ match }) {
  const queryString = getQueryStringObject()
  const initList = queryString?.list
  const scrollRef = useRef(null)
  const history = useHistory()
  const mainminiBannerLink =
    process.env.REACT_APP_ENV === 'qa' || process.env.REACT_APP_ENV === 'dev'
      ? '/motishop/product/181'
      : '/motishop/product/135'
  return (
    <>
      <MainInner ref={scrollRef}>
        <MainHeaderContainer />
        <MainBannerWrapper>
          <MainBanner />
        </MainBannerWrapper>
        <BranddakBannerWrapper>
          <img
            src={charmden}
            alt={'참든'}
            onClick={() => {
              // window.open('https://m.branddak.com/product/detail.html?product_no=417', '_blank')
              // history.push(
              //   process.env.REACT_APP_ENV === 'qa' || process.env.REACT_APP_ENV === 'dev'
              //     ? '/motishop/product/173'
              //     : '/motishop/product/116',
              // )
              history.push(mainminiBannerLink)
            }}
          />
        </BranddakBannerWrapper>
        {/* <MotishopBannerWrapper>
        <MotishopBanner />
      </MotishopBannerWrapper> */}
        <MainList scrollRef={scrollRef} initList={initList} />
      </MainInner>
      {/* <BranddakModal /> */}
      {/* <CharmdenModal /> */}
    </>
  )
}
